import React from 'react';
import withWindowResize from '../../ui/components/window-resize';
import ProductCarousel from './product-carousel';

export default withWindowResize( props => <ProductCarousel {...props} /> );